/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BackOfficeConfigDto } from '../models/back-office-config-dto';
import { getConfig } from '../fn/config/get-config';
import { GetConfig$Params } from '../fn/config/get-config';
import { getEncryptionKeyExportSalt } from '../fn/config/get-encryption-key-export-salt';
import { GetEncryptionKeyExportSalt$Params } from '../fn/config/get-encryption-key-export-salt';
import { storeDocumentEncryptionPublicKey } from '../fn/config/store-document-encryption-public-key';
import { StoreDocumentEncryptionPublicKey$Params } from '../fn/config/store-document-encryption-public-key';

@Injectable({ providedIn: 'root' })
export class GeneratedConfigService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getConfig()` */
  static readonly GetConfigPath = '/api/config';

  /**
   * Gets the configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfig$Response(params?: GetConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<BackOfficeConfigDto>> {
    return getConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfig(params?: GetConfig$Params, context?: HttpContext): Observable<BackOfficeConfigDto> {
    return this.getConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<BackOfficeConfigDto>): BackOfficeConfigDto => r.body)
    );
  }

  /** Path part for operation `storeDocumentEncryptionPublicKey()` */
  static readonly StoreDocumentEncryptionPublicKeyPath = '/api/config/DocumentEncryptionPublicKey';

  /**
   * Stores a new public key for document encryption.
   *
   * NOTE: Will fail when there is already a public key set.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storeDocumentEncryptionPublicKey()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  storeDocumentEncryptionPublicKey$Response(params?: StoreDocumentEncryptionPublicKey$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return storeDocumentEncryptionPublicKey(this.http, this.rootUrl, params, context);
  }

  /**
   * Stores a new public key for document encryption.
   *
   * NOTE: Will fail when there is already a public key set.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `storeDocumentEncryptionPublicKey$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  storeDocumentEncryptionPublicKey(params?: StoreDocumentEncryptionPublicKey$Params, context?: HttpContext): Observable<void> {
    return this.storeDocumentEncryptionPublicKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getEncryptionKeyExportSalt()` */
  static readonly GetEncryptionKeyExportSaltPath = '/api/config/EncryptionKeyExportSalt';

  /**
   * Gets the system-wide salt for exported encryption keys.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEncryptionKeyExportSalt()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEncryptionKeyExportSalt$Response(params?: GetEncryptionKeyExportSalt$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return getEncryptionKeyExportSalt(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the system-wide salt for exported encryption keys.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEncryptionKeyExportSalt$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEncryptionKeyExportSalt(params?: GetEncryptionKeyExportSalt$Params, context?: HttpContext): Observable<string> {
    return this.getEncryptionKeyExportSalt$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
